import { ProModeSkus } from "@petergok/blue-collar-shared";

type WebStripeSkuSet = {
  aiSub?: string;
  apprenticeTrack?: string;
  legacy?: string;
  lifetime?: string;
  sub?: string;
  subMonthly?: string;
  upgrade?: string;
};

export type WebProModeSkus = {
  development?: WebStripeSkuSet;
  production?: WebStripeSkuSet;
};

/**
 * Maps web app SKU structure to shared package ProModeSkus structure.
 */
export function buildProModeSkus(webSkus: WebProModeSkus): ProModeSkus {
  return {
    stripe: {
      production: {
        legacyStripe: webSkus.production?.legacy,
        subStripe: webSkus.production?.sub,
        subMonthlyStripe: webSkus.production?.subMonthly,
        lifetimeStripe: webSkus.production?.lifetime,
        upgradeStripe: webSkus.production?.upgrade,
        aiSubStripe: webSkus.production?.aiSub,
        apprenticeTrackStripe: webSkus.production?.apprenticeTrack,
      },
      development: {
        legacyStripe: webSkus.development?.legacy,
        subStripe: webSkus.development?.sub,
        subMonthlyStripe: webSkus.development?.subMonthly,
        lifetimeStripe: webSkus.development?.lifetime,
        upgradeStripe: webSkus.development?.upgrade,
        aiSubStripe: webSkus.development?.aiSub,
        apprenticeTrackStripe: webSkus.development?.apprenticeTrack,
      },
    },
  };
}
